/* =========================================================
   Mobile: Move product title + price above gallery thumbnails
   ========================================================= */
(function () {
  function repositionElements() {
    const isMobile = window.innerWidth <= 749;
    const title = document.querySelector('.product__title');
    const priceBlock = document.querySelector('[id^="price-"]');
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    const productGrid = mediaWrapper ? mediaWrapper.parentElement : null;

    if (!title || !mediaWrapper || !productGrid) return;

    if (isMobile && !title.classList.contains('mobile-above-gallery')) {
      // Save original positions
      title._originalParent = title.parentElement;
      title._originalNext = title.nextElementSibling;

      // Move title before the gallery
      productGrid.insertBefore(title, mediaWrapper);
      title.classList.add('mobile-above-gallery');

      // Move price right after the title (before gallery)
      if (priceBlock) {
        priceBlock._originalParent = priceBlock.parentElement;
        priceBlock._originalNext = priceBlock.nextElementSibling;
        productGrid.insertBefore(priceBlock, mediaWrapper);
        priceBlock.classList.add('mobile-above-gallery');
      }
    } else if (!isMobile && title.classList.contains('mobile-above-gallery')) {
      // Restore price to original position first
      if (priceBlock && priceBlock.classList.contains('mobile-above-gallery')) {
        if (priceBlock._originalParent) {
          priceBlock._originalParent.insertBefore(
            priceBlock,
            priceBlock._originalNext || null
          );
        }
        priceBlock.classList.remove('mobile-above-gallery');
      }

      // Restore title to original position
      if (title._originalParent) {
        title._originalParent.insertBefore(
          title,
          title._originalNext || title._originalParent.firstChild
        );
      }
      title.classList.remove('mobile-above-gallery');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', repositionElements);
  } else {
    repositionElements();
  }
  window.addEventListener('resize', repositionElements);
})();

if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        // Prevent clicks on content area and nav arrows from closing the modal
        // (ModalDialog's pointerup handler on .media-modal closes on any click
        //  not inside deferred-media or product-model)
        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          content.addEventListener('pointerup', (e) => e.stopPropagation());
        }

        // Nav arrow references
        this.prevBtn = this.querySelector('.lightbox-nav-prev');
        this.nextBtn = this.querySelector('.lightbox-nav-next');
        this.counter = this.querySelector('.lightbox-counter');

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.navigatePrev();
          });
          this.prevBtn.addEventListener('pointerup', (e) => e.stopPropagation());
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.navigateNext();
          });
          this.nextBtn.addEventListener('pointerup', (e) => e.stopPropagation());
        }

        // Bound handlers for cleanup
        this._onKeyDown = this.handleKeyDown.bind(this);
        this._onTouchStart = this.handleTouchStart.bind(this);
        this._onTouchMove = this.handleTouchMove.bind(this);
        this._onTouchEnd = this.handleTouchEnd.bind(this);

        this.currentIndex = 0;
        this.touchStartX = 0;
        this.touchStartY = 0;
        this.touchDeltaX = 0;
        this.isSwiping = false;
      }

      hide() {
        super.hide();
        document.removeEventListener('keydown', this._onKeyDown);

        const content = this.querySelector('.product-media-modal__content');
        if (content) {
          content.removeEventListener('touchstart', this._onTouchStart);
          content.removeEventListener('touchmove', this._onTouchMove);
          content.removeEventListener('touchend', this._onTouchEnd);
        }
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();

        // Move close button inside content card so it positions relative to card
        const content = this.querySelector('.product-media-modal__content');
        const toggle = this.querySelector('.product-media-modal__toggle');
        if (content && toggle && toggle.parentElement !== content) {
          content.appendChild(toggle);
        }

        // Add "Close" text label to close button if not already there
        if (toggle && !toggle.querySelector('.close-label')) {
          const label = document.createElement('span');
          label.className = 'close-label';
          label.textContent = 'Close';
          label.style.cssText = 'color:#fff;font-size:10px;position:absolute;bottom:-14px;left:50%;transform:translateX(-50%);white-space:nowrap;';
          toggle.style.overflow = 'visible';
          toggle.appendChild(label);
        }

        // Close modal when clicking the dark backdrop (outside the content card)
        const dialog = this.querySelector('.product-media-modal__dialog');
        if (dialog && !dialog._backdropHandler) {
          dialog._backdropHandler = (e) => {
            // Only close if the click target is the dialog itself (backdrop area)
            if (e.target === dialog) {
              this.hide();
            }
          };
          dialog.addEventListener('click', dialog._backdropHandler);
        }

        // Add keyboard navigation
        document.addEventListener('keydown', this._onKeyDown);

        // Add touch/swipe support
        if (content) {
          content.addEventListener('touchstart', this._onTouchStart, { passive: true });
          content.addEventListener('touchmove', this._onTouchMove, { passive: false });
          content.addEventListener('touchend', this._onTouchEnd, { passive: true });
        }
      }

      /** Get ordered list of visible (non-hidden) media items in the modal */
      getVisibleMediaItems() {
        return Array.from(this.querySelectorAll('[data-media-id]')).filter(
          (el) => !el.classList.contains('hide-image')
        );
      }

      showActiveMedia() {
        const items = this.getVisibleMediaItems();
        const openedMediaId = this.openedBy?.getAttribute('data-media-id');

        // Remove active from all
        this.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.remove('active');
        });

        // Find and activate the opened media
        let activeMedia = null;
        this.currentIndex = 0;

        for (let i = 0; i < items.length; i++) {
          if (items[i].getAttribute('data-media-id') === openedMediaId) {
            activeMedia = items[i];
            this.currentIndex = i;
            break;
          }
        }

        // Fallback to first visible item
        if (!activeMedia && items.length > 0) {
          activeMedia = items[0];
          this.currentIndex = 0;
        }

        if (activeMedia) {
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView({ block: 'nearest' });

          // Load deferred media (YouTube videos, etc.)
          const template = activeMedia.querySelector('template');
          const content = template ? template.content : null;
          if (
            activeMedia.nodeName === 'DEFERRED-MEDIA' &&
            content &&
            content.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        }

        this.updateNavigation();
      }

      navigateTo(index) {
        const items = this.getVisibleMediaItems();
        if (index < 0 || index >= items.length) return;

        // Pause any playing media
        window.pauseAllMedia();

        // Remove active from all
        this.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.remove('active');
        });

        // Activate target
        const target = items[index];
        target.classList.add('active');
        this.currentIndex = index;

        // Load deferred media if needed
        const template = target.querySelector('template');
        const content = template ? template.content : null;
        if (
          target.nodeName === 'DEFERRED-MEDIA' &&
          content &&
          content.querySelector('.js-youtube')
        ) {
          target.loadContent();
        }

        this.updateNavigation();
      }

      navigatePrev() {
        if (this.currentIndex > 0) {
          this.navigateTo(this.currentIndex - 1);
        }
      }

      navigateNext() {
        const items = this.getVisibleMediaItems();
        if (this.currentIndex < items.length - 1) {
          this.navigateTo(this.currentIndex + 1);
        }
      }

      updateNavigation() {
        const items = this.getVisibleMediaItems();
        const total = items.length;

        // Update prev/next visibility
        if (this.prevBtn) {
          if (this.currentIndex <= 0) {
            this.prevBtn.setAttribute('hidden', '');
          } else {
            this.prevBtn.removeAttribute('hidden');
          }
        }

        if (this.nextBtn) {
          if (this.currentIndex >= total - 1) {
            this.nextBtn.setAttribute('hidden', '');
          } else {
            this.nextBtn.removeAttribute('hidden');
          }
        }

        // Update counter
        if (this.counter) {
          if (total <= 1) {
            this.counter.style.display = 'none';
          } else {
            this.counter.style.display = '';
            this.counter.textContent = `${this.currentIndex + 1} / ${total}`;
          }
        }
      }

      handleKeyDown(event) {
        if (event.key === 'ArrowLeft' || event.key === 'Left') {
          event.preventDefault();
          this.navigatePrev();
        } else if (event.key === 'ArrowRight' || event.key === 'Right') {
          event.preventDefault();
          this.navigateNext();
        }
      }

      handleTouchStart(event) {
        if (event.touches.length !== 1) return;
        this.touchStartX = event.touches[0].clientX;
        this.touchStartY = event.touches[0].clientY;
        this.touchDeltaX = 0;
        this.isSwiping = false;
      }

      handleTouchMove(event) {
        if (event.touches.length !== 1) return;
        const deltaX = event.touches[0].clientX - this.touchStartX;
        const deltaY = event.touches[0].clientY - this.touchStartY;

        // Determine if horizontal swipe (only on first significant movement)
        if (!this.isSwiping && (Math.abs(deltaX) > 10 || Math.abs(deltaY) > 10)) {
          this.isSwiping = Math.abs(deltaX) > Math.abs(deltaY);
        }

        if (this.isSwiping) {
          event.preventDefault(); // Prevent vertical scroll during horizontal swipe
          this.touchDeltaX = deltaX;
        }
      }

      handleTouchEnd() {
        if (!this.isSwiping) return;

        const threshold = 50; // Minimum swipe distance in pixels
        if (this.touchDeltaX > threshold) {
          this.navigatePrev(); // Swipe right = previous
        } else if (this.touchDeltaX < -threshold) {
          this.navigateNext(); // Swipe left = next
        }

        this.isSwiping = false;
        this.touchDeltaX = 0;
      }
    }
  );
}
